/* eslint-disable no-unused-vars */
import React from 'react';
import ContactForm from '../ContactFrom/ContactForm'
import { useLanguage } from '../../i18n/LanguageContext';


const Contactpage = () => {
    const { t } = useLanguage();

    return(
        <section className="wpo-contact-pg-section section-padding">
            <div className="container">
                <div className="row">
                    <div className="col col-lg-10 offset-lg-1">
                        <div className="office-info">
                            <div className="row">
                                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                                    <div className="office-info-item">
                                        <div className="office-info-icon">
                                            <div className="icon">
                                                <i className="fi flaticon-maps-and-flags"></i>
                                            </div>
                                        </div>
                                        <div className="office-info-text">
                                            <h2>{t('contact.addressTitle')}</h2>
                                            <p>{t('contact.venue')}</p>
                                            <p>{t('contact.address')}</p>
                                            <p>{t('contact.access')}</p>
                                        </div>
                                    </div>
                                </div> 
                                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                                    <div className="office-info-item">
                                        <div className="office-info-icon">
                                            <div className="icon">
                                                <i className="fi flaticon-email"></i>
                                            </div>
                                        </div>
                                        <div className="office-info-text">
                                            <h2>{t('contact.contactTitle')}</h2>
                                            <p>{t('contact.suzuki')}</p>
                                            <p>suzuya@tea.ocn.ne.jp ({t('contact.email')})</p>
                                            <p>090-3334-3566 ({t('contact.phone')})</p>
                                            <p>{t('contact.liu')}</p>
                                            <p>constljx@gmail.com ({t('contact.email')})</p>
                                            
                                        </div>
                                    </div>
                                </div> 
                                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                                    <div className="office-info-item">
                                        <div className="office-info-icon">
                                            <div className="icon">
                                                <i className="fi flaticon-phone-call"></i>
                                            </div>
                                        </div>
                                        <div className="office-info-text">
                                            <h2>{t('contact.hoursTitle')}</h2>
                                            <p>{t('contact.hours')}</p>
                                            <p>{t('contact.holidays')}</p>
                                            <p>{t('contact.fee')}</p>
                                        </div>
                                    </div>
                                </div> 
                            </div>
                        </div>
                        {/* <div className="wpo-contact-title">
                            <h2>お問い合わせ</h2>
                            <p>申し訳ございません、本機能開発中のために、現在ご利用できません。</p>
                        </div>
                        <div className="wpo-contact-form-area">
                            <ContactForm/>
                        </div> */}
                    </div>                
                </div>
            </div> 
            <section className="wpo-contact-map-section">
                <div className="wpo-contact-map">
                    <iframe title='comtact-map' src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3239.305631379006!2d139.85110127578938!3d35.71870127257509!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzXCsDQzJzA3LjMiTiAxMznCsDUxJzEzLjIiRQ!5e0!3m2!1sja!2sjp!4v1704368725406!5m2!1sja!2sjp"></iframe>
                </div>
            </section>
        </section>
     )
        
}

export default Contactpage;
